import {
    Component,
    Input,
    OnInit,
    ElementRef,
    ViewEncapsulation,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { IconService } from './icon.service';
import { Subject } from 'rxjs';
import { OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { takeUntil, map, filter } from 'rxjs/operators';

@Component({
    selector: 'pay-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'c-icon',
    },
})
export class IconComponent implements OnInit, OnDestroy, OnChanges {
    @Input() name: string;

    private destroyed$: Subject<void> = new Subject();
    private iconPrefix: string = 'icon-';
    private nativeElement: HTMLElement;

    constructor(
        private element: ElementRef,
        private iconsService: IconService,
        private cdr: ChangeDetectorRef
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    ngOnInit() {
        this.iconsService
            .getIcons()
            .pipe(
                takeUntil(this.destroyed$),
                map((icons) => icons[this.iconPrefix + this.name]),
                filter((icon) => icon)
            )

            .subscribe((icon) => {
                return this.populateIcon(icon)
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes &&
            changes['name'] &&
            changes['name'].currentValue !== changes['name'].previousValue &&
            !changes['name'].isFirstChange()
        ) {
            this.iconsService.refreshIcons();
        }
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    private populateIcon(icon: string) {
        this.nativeElement.innerHTML = icon;
        this.cdr.markForCheck();
    }
}
